import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, PrimaryButton, Tooltip, getPaymentProcessorTitle, toast, useTranslation as useUiTranslation } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { gocardlessDisconnect } from 'modules/profile/payment-gateways/integrations/gocardless/api';
import { useGoCardlessConnect } from 'modules/profile/payment-gateways/integrations/gocardless/hooks';
import { GocardlessPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/gocardless/types';
import { getGoCardlessHelpPageLink } from 'modules/profile/payment-gateways/integrations/gocardless/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, GoCardlessLogoIcon } from '@systemeio/ui/icons';
export const Gocardless: FC = () => {
  const $ = _c(5);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.Gocardless
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const gocardlessIntegration = t0;
  const title = getPaymentProcessorTitle(PaymentProcessorEnum.Gocardless, tUi);
  const {
    getGoCardlessAuthorizationLink
  } = useGoCardlessConnect();
  const onDelete = async () => {
    await gocardlessDisconnect();
    await removePaymentIntegration({
      processor: PaymentProcessorEnum.Gocardless
    });
    toast.success(t("dashboard.settings.payment-gateways.account_removed", {
      payment: title
    }));
  };
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GoCardlessLogoIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = user?.dashboardLocale;
  let t3;
  if ($[3] !== t2) {
    t3 = getGoCardlessHelpPageLink(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return <Integration logo={t1} additionalInfo={<a className="primary-link" href={t3} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
      integration: title
    }} /></a>}>{gocardlessIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!gocardlessIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}{gocardlessIntegration.details.organizationName && <p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.organization_name")}:`}</span><span className="text-text-primary truncate">{gocardlessIntegration.details.organizationName}</span></p>}</div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
        payment: title
      })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
        payment: title
      })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.gocardless")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <PrimaryButton onClick={e => {
      e.preventDefault();
      getGoCardlessAuthorizationLink();
    }} className="font-bold">{t("dashboard.settings.payment_gateways.connect")}</PrimaryButton>}</Integration>;
};